export default {
  getters: {
    contacts(state) {
      return state.contacts;
    },
  },
};
